<template>
  <div>
    <back-btn />
    <v-card>
      <v-card-text>
        <h2>DOT Visit Export</h2>
        <v-row>
          <v-col lg="12">
            <label>App Use</label>
            <v-radio-group v-model="appUse" row>
              <v-radio label="App Use" :value="2"></v-radio>
              <v-radio label="No App Use" :value="1"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="3">
            <label>From Date</label>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="visit_date_from"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="visit_date_from"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="3">
            <label>To Date</label>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="visit_date_to"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="visit_date_to"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="3"><br>
            <v-btn
              class="form-btn"
              @click="exportData"
              :loading="isLoading"
            >
              <v-progress-circular
                v-if="isLoading"
                indeterminate
                color="white"
                size="20"
                width="2"
                class="mr-2"
              ></v-progress-circular>
              <v-icon v-else left>mdi-chevron-right-circle-outline</v-icon>
              {{ isLoading ? 'Loading...' : 'Export' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  components: {},
  data: () => ({
    appUse: 2,
    visit_date_from: null,
    visit_date_to: null,
    menu: false,
    menu2: false,
    isLoading: false,
  }),
  methods: {
    exportData() {
      let data = {};

      if (this.visit_date_from && this.visit_date_to) {
        data.visit_date_from = moment(this.visit_date_from).format("YYYY-MM-DD");
        data.visit_date_to = moment(this.visit_date_to).format("YYYY-MM-DD");

        if (data.visit_date_from > data.visit_date_to) {
          data.visit_date_from = null;
          data.visit_date_to = null;
          alert("Cannot be greater than From Date");
          return false;
        }
      } else {
        data.visit_date_from = null;
        data.visit_date_to = null;
        alert("Please select From and To date");
        return false;
      }

      data.dots_app_status = this.appUse;
      this.isLoading = true;
      this.$store
        .dispatch("Presumptive/dotsVisitExport", data)
        .catch(() => {
          alert("Failed to export. Please try again.");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped></style>
